var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.__class,attrs:{"id":_vm._comId}},[_c('div',{staticClass:"mask",style:({'z-index': _vm.zindex})}),_c('table',{staticClass:"loading",style:({'z-index':_vm.zindex||1})},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('i',{staticClass:"fa fa-spinner fa-spin"})])])
}]

export { render, staticRenderFns }